import React from 'react';
import { IoCheckmark, IoCheckmarkDone } from 'react-icons/io5';

import { List, ListItem, MantineSpacing, Text, ThemeIcon } from '@mantine/core';

export const FeatureItems = ({
    items,
    highlight,
    spacing = 'xl',
    maw,
}: {
    items: { title: string; description?: string }[];
    highlight?: boolean;
    spacing?: MantineSpacing;
    maw?: number;
}) => {
    return (
        <List
            pl={0}
            spacing={spacing}
            icon={
                <ThemeIcon
                    size={32}
                    radius={99}
                    variant={highlight ? 'filled' : 'light'}
                    color={highlight ? 'brand' : 'gray'}
                >
                    {highlight ? <IoCheckmarkDone size={16} /> : <IoCheckmark size={16} />}
                </ThemeIcon>
            }
            maw={maw}
        >
            {items.map((item) => (
                <ListItem key={item.title}>
                    <Text fz="lg" fw={700} c="black">
                        {item.title}
                    </Text>
                    <Text fz="md" c="gray.7">
                        {item.description}
                    </Text>
                </ListItem>
            ))}
        </List>
    );
};
